module.exports = __webpack_public_path__ + "static/03-8b530322aa83719b545ba401de8430b1.jpg";